import clsx from 'clsx'
import {useAuth} from '@/app/modules/auth'
import {toAbsoluteUrl} from '../../../helpers'
import {HeaderUserMenu, ThemeModeSwitcher} from '../../../partials'

const itemClass = 'ms-1 ms-md-4'
const userAvatarClass = 'symbol-35px'

const Navbar = () => {
  const {currentUser} = useAuth()
  const fallbackAvatar = toAbsoluteUrl('/media/svg/avatars/blank.svg')

  return (
    <div className='app-navbar flex-shrink-0'>
      <div className={clsx('app-navbar-item', itemClass)}>
        <ThemeModeSwitcher toggleBtnClass={clsx('btn-active-light-primary btn-custom')} />
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          className={clsx('cursor-pointer symbol', userAvatarClass)}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <img
            src={currentUser?.detail_data?.url_profile_picture?.trim() || fallbackAvatar}
            alt={currentUser?.detail_data?.fullname || 'User profile'}
            style={{objectFit: 'cover'}}
            onError={(event) => {
              if (event.currentTarget.getAttribute('src') !== fallbackAvatar) {
                event.currentTarget.src = fallbackAvatar
              }
            }}
          />
        </div>
        <HeaderUserMenu />
      </div>
    </div>
  )
}

export {Navbar}
